import { indentedListToTree, treeToIndentedList } from './data-structure-conversion'

export class Migration_200521_intendedListToTree {
    up(state) {
        return { ...state, nodes: indentedListToTree(state.nodes) }
    }

    down(state) {
        return { ...state, nodes: treeToIndentedList(state.nodes) }
    }
}
